import React from 'react';
import { View, ScrollView } from 'react-native';
import ViewShot from 'react-native-view-shot';
import ChildrenBarGraphWeb from '../../../graphs/ChildrenBarGraphWeb';
import ChildrenBarGraph from '../../../graphs/ChildrenBarGraph';
import isMobile from '../../../components/IsMobile';
import WidgetHeader from './WidgetHeader';
import Style from '../../../constants/Style';
import { SolveAnalyticsWidgetProps } from '../Utils';

const TicketsPerAsset = ({
  range, compareRange, viewShotRef, data, comparisonData,
}: SolveAnalyticsWidgetProps) => {
  const compareToggled: boolean = !!compareRange.start && !!compareRange.end;

  return <View
    style={[
      Style.commonCardStyle,
      isMobile ? { width: '100%', paddingHorizontal: 20 } : { height: 520 },
    ]}
    testID='sa-tickets-raised-per-asset-chart'
  >
    <WidgetHeader
      title='Tickets raised per asset'
      {...{ range, compareRange }}
      tooltipText='List of assets with the most tickets raised against them, sorted in descending order of the number of tickets'
    />
    <ViewShot ref={viewShotRef}>
      {isMobile ? <ScrollView
        horizontal
        style={{ zIndex: -1 }}>
        <ChildrenBarGraph {...{ data, comparisonData, compareToggled }} />
      </ScrollView> : <ChildrenBarGraphWeb {...{ data, comparisonData, compareToggled }} />}
    </ViewShot>
  </View>;
};

export default TicketsPerAsset;
